import { withAuth } from '../../../system-utils/api-utils';
import { constructGet9SpokesRedirectApiUrl } from './urls';

/**
 * Calls the api to retrieve 9Spokes redirect URL
 * @returns
 */
export const postGetThirdPartyRedirect = () =>
  withAuth<{ redirectUrl: string }>(({ headers }) =>
    fetch(constructGet9SpokesRedirectApiUrl(), {
      method: 'POST',
      headers,
    }),
  );
